import { API_ENDPOINT } from "@/constants/appConstants";

export type AutoApplyData = {
  auto_apply_status?: {
    status?: string | null;
  } | null;

  personalDetailSection?: {
    personalDetails?: {
      additionalPersonalDetail?: {
        experience?: {
          years?: number;
        } | null;
      } | null;
    } | null;
  } | null;

  jobPreferenceSection?: {
    jobPreference?: { locations: any; roles: any };
  };

  skillSection: {
    skills?: any;
  };
};

export const fetchAutoApply = async (): Promise<AutoApplyData> => {
  const response = await fetch(
    `${API_ENDPOINT(window.location.host).middleware.profileDetails}?fields=job_preferences,skills_and_it_skills,auto_apply_status`,
  );

  if (!response.ok) {
    throw new Error("Failed to fetch Auto Apply data");
  }

  return response.json();
};
